import React from 'react';
import { BookOpenIcon, PrinterIcon } from 'lucide-react';
const BENEFITS = [{
  icon: PrinterIcon,
  title: 'Moldes listos para imprimir',
  text: 'No tenés que diseñar ni dibujar tus propios patrones. Elegí el modelo, imprimí los moldes en A4 y prepará las piezas para empezar a confeccionar.'
}, {
  icon: BookOpenIcon,
  title: 'Ideal para principiantes',
  text: 'Cada modelo incluye su manual de confección con instrucciones paso a paso, desde la preparación y el corte hasta el armado y las terminaciones.'
}];

/** "Qué incluye": two short benefits, no price. */
export function BenefitsSection() {
  return <section aria-labelledby="beneficios-title" className="w-full bg-ivory" data-id="element-172" data-mp="1mkgcxj9krpib">
      <div className="mx-auto max-w-6xl px-5 py-12 sm:px-8 lg:py-16" data-id="element-173" data-mp="1hmeu8zg29s7d">
        <h2 id="beneficios-title" className="sr-only" data-id="element-174" data-mp="b7noahc2zh6h">
          Qué incluye la colección
        </h2>
        <ul className="grid grid-cols-1 gap-x-10 divide-y divide-dashed divide-coral/35 md:grid-cols-2 md:gap-y-10 md:divide-y-0 [&>*]:min-w-0" data-id="element-175" data-mp="67i2viwemqwu">
          {BENEFITS.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4 py-5 first:pt-0 last:pb-0 md:flex-col md:gap-3 md:py-0" data-id="element-176" data-mp="1kztuthrjv5ju">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blush text-coral-ink" data-id="element-177" data-mp="16yprqy8ii995">
                <Icon className="h-5 w-5" aria-hidden data-id="element-178" data-mp="1bxascyroeuy4" />
              </span>
              <div className="min-w-0" data-id="element-179" data-mp="x8wqaq233aim">
                <h3 className="font-serif text-[1.3rem] font-semibold leading-tight text-graphite sm:text-[1.45rem]" data-id="element-180" data-mp="x7v4bqjj53m4">{title}</h3>
                <p className="mt-1.5 text-[1rem] leading-relaxed text-graphite-soft" data-id="element-181" data-mp="o9jh7yhvgnyf">{text}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}